import { formatInTimeZone } from "date-fns-tz"

export function timestampToDateString(timestamp: number | null): string {
    if (!timestamp) {
        return "-"
    }
    const formatDate = "yyyy.MM.dd."

    return timestamp !== 0 ? formatInTimeZone(timestamp * 1000, "Europe/Budapest", formatDate) : "-"
}
